import type { IconData } from '@stacksjs/iconify-core'

export const grid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22 6H2V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1z\"/><path fill=\"currentColor\" d=\"M2 8h9v6H2zm0 8h9v6H3a1 1 0 0 1-1-1zm11-8h9v6h-9zm8 14h-8v-6h9v5a1 1 0 0 1-1 1\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M22 8V6H2v2h9v6H2v2h9v6h2v-6h9v-2h-9V8z\" opacity=\".25\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default grid
